import CommonBreadCrumbs from "@/components/common/bread-crumbs"
import "@/styles/routes/personal-information.scss"
import { getTemplatedMetaArray } from "@/utils/getTemplatedMetaArray"
import type { MetaFunction } from "react-router"

export const meta: MetaFunction = ({ matches }) => {
  return getTemplatedMetaArray(matches, {
    title: "個人情報の取り扱い | コタエルHR",
    description:
      "コタエルHRは人と組織にまつわる課題を解決し、成長を目指す企業の未来をつくります。さまざまなHRサービスの提供を通じて、組織の進化を加速させます。",
  })
}

export default function PersonalInformation() {
  const breadcrumbs = [
    { name: "HOME", url: "/" },
    {
      name: "当社における個人情報の取り扱いについて",
      url: "",
    },
  ]

  return (
    <>
      <div className="content">
        <h1 className="title">当社における個人情報の取扱いについて</h1>

        <section className="section">
          <h2 className="section_title">1.個人情報の利用目的</h2>
          <table className="table">
            <tbody>
              <tr>
                <td className="item">
                  お取引先様から委託を受ける業務において取り扱う個人情報
                </td>
                <td className="item_content">
                  クライアント企業様からの委託を受けた人事制度策定支援業務、組織構築支援業務、人材紹介事業を契約内容に従って適切に遂行するため
                </td>
              </tr>
              <tr>
                <td className="item">電話でお問合せいただいた方の個人情報</td>
                <td className="item_content">
                  お問合せに対して適切に対応し管理するため
                </td>
              </tr>
              <tr>
                <td className="item">採用応募サイトより取得する個人情報</td>
                <td className="item_content">
                  採用選考及び必要となるご連絡のため
                </td>
              </tr>
            </tbody>
          </table>
          <p className="note">
            ※なお、直接書面により取得する個人情報の利用目的については、以下に記載する保有個人データの利用目的をご参照ください
          </p>
        </section>

        <section className="section">
          <h2 className="section_title">
            2.当社の保有個人データまたは第三者提供記録について
          </h2>
          <p className="text">
            当社で保有している保有個人データ又は第三者提供記録に関して、ご本人様又はその代理人様からの利用目的の通知、開示、内容の訂正、追加又は削除、利用の停止、消去及び第三者への提供の停止、第三者提供記録の開示の請求（以下、「開示等の請求」といいます）につきましては、当社所定の請求書により、以下の手続きにて対応させていただきます。
          </p>
          <h3 className="section_subtitle">
            2-1. 個人情報取扱事業者の名称及び住所並びに代表者の氏名
          </h3>
          <p className="text">
            名称： コタエルHR株式会社
            <br />
            住所： 〒105-0001 東京都港区虎ノ門 1-17-1 虎ノ門ヒルズビジネスタワー
            15階
            <br />
            代表者の氏名： 小林弘樹
          </p>
          <h3 className="section_subtitle">
            2-2. 個人情報保護管理者の職名、所属及び連絡先
          </h3>
          <p className="text">
            コタエルHR株式会社 個人情報保護管理者&nbsp;多賀
            <br />
            （連絡先は下記「個人情報苦情及び相談窓口」）
          </p>
          <h3 className="section_subtitle">
            2-3. すべての保有個人データの利用目的
          </h3>
          <ol className="list">
            <li className="list_item">
              <h4 className="list_item_title">(1)お客様の個人情報</h4>
              <p className="list_item_text">
                ご契約内容を実施し適切に管理するため
              </p>
            </li>
            <li className="list_item">
              <h4 className="list_item_title">(2)お取引先様の個人情報</h4>
              <p className="list_item_text">
                お取引先様との間のご契約内容を適切に管理するため
              </p>
            </li>
            <li className="list_item">
              <h4 className="list_item_title">
                (3)人材紹介サポート希望者様の個人情報
              </h4>
              <p className="list_item_text">適切な企業をご紹介するため</p>
            </li>
            <li className="list_item">
              <h4 className="list_item_title">(4)株主の皆様の個人情報</h4>
              <ul className="list_sub">
                <li className="list_sub_item">
                  会社法及び商法に基づく権利の行使・義務の履行のため
                </li>
                <li>当社から各種便宜を供与するため</li>
                <li>
                  株主と会社の関係の円滑化を図るための各種の施策を実施するため
                </li>
                <li>
                  各種法令に基づき所定の基準による株主のデータを作成する等、株主管理のため
                </li>
              </ul>
            </li>
            <li className="list_item">
              <h4 className="list_item_title">
                (5)当社への入社を希望される皆様の個人情報
              </h4>
              <ul className="list_sub">
                <li className="list_sub_item">
                  就職先としてご興味をお持ちになった方並びにご応募いただいた方への採用、募集情報等の提供・連絡のため
                </li>
                <li className="list_sub_item">採用選考業務のため</li>
              </ul>
            </li>
            <li className="list_item">
              <h4 className="list_item_title">(6)当社の社員の個人情報</h4>
              <ul className="list_sub">
                <li className="list_sub_item">
                  業務上の連絡、社員名簿の作成、法律上要求される諸手続(本人退職後も含む)、その他雇用管理のため。
                </li>
                <li className="list_sub_item">
                  人事選考、配属先および出向、派遣先の決定のため。
                </li>
                <li className="list_sub_item">
                  報酬の決定および支払、税務処理、社会保険関連の手続き、福利厚生の提供のため。
                </li>
                <li className="list_sub_item">
                  ビデオ及びオンラインによるモニタリング等における安全管理措置のため。
                </li>
                <li className="list_sub_item">
                  当社PR又は宣伝資料等における当社PR又は宣伝活動等のため。
                </li>
                <li className="list_sub_item">
                  適正な健康管理のため。(健康診断の結果等の労働者の健康情報については、法令に基づく場合を除いて、取得、利用又は提供を行いません。)
                </li>
              </ul>
            </li>
            <li className="list_item">
              <h4 className="list_item_title">
                (7)当社へお問合せ頂いた方の個人情報
              </h4>
              <ul className="list_sub">
                <li className="list_sub_item">当社の接客態度等の向上のため</li>
                <li className="list_sub_item">
                  お問い合わせやご連絡内容を正確に把握し、対処するため
                </li>
              </ul>
            </li>
            <li className="list_item">
              <h4 className="list_item_title">(8)特定個人情報等</h4>
              <p className="list_item_text">
                源泉徴収票・支払調書作成事務、健康保険・厚生年金保険届出事務、雇用保険届出事務を法令に基づき適切に実施するため
              </p>
            </li>
          </ol>
          <p className="note">
            ※上記利用目的において、「ご契約内容を適切に管理するため」としているものは、「契約に入る前の段階における利用」と「契約終了後における利用」を含みます。
          </p>
          <h3 className="section_subtitle">
            2-4. 保有個人データの取扱いに関する苦情の申し出先
          </h3>
          <p className="text">「個人情報苦情及び相談窓口」（末尾に記載）</p>
          <h3 className="section_subtitle">
            2-5. 認定個人情報保護団体の名称及び苦情の解決の申し出先
          </h3>
          <p className="text">
            現在当社は、認定個人情報保護団体の対象事業者ではございません。
          </p>
          <h3 className="section_subtitle">2-6. 開示等の請求等に応じる手続</h3>
          <h4 className="section_subtitle_lower">
            2-6-1. 開示等の請求等に応じる手続
          </h4>
          <p className="text">「個人情報苦情及び相談窓口」（末尾に記載）</p>
          <div className="disclosure_wrapper">
            <h4 className="section_subtitle_lower">
              2-6-2.
              開示等の請求等に際して提出すべき書面の様式その他の開示等の請求等の方式
            </h4>
            <p className="text">
              下記を当社「個人情報苦情及びご相談窓口」まで、郵便又は宅配便でご送付ください。遅滞なく迅速に対応いたします。なお郵便又は宅配便以外の手段（直接のご来社、電子メール、FAXなど）での開示等の請求等は受け付けておりません。
            </p>
            <ol className="disclosure">
              <li className="disclosure_item">
                <h5 className="section_subtitle_lower">
                  1.当社指定の「開示等の請求等申請書」
                </h5>
                <p className="text">
                  下記を当社「個人情報苦情及びご相談窓口」まで、郵便又は宅配便でご送付ください。遅滞なく迅速に対応いたします。なお郵便又は宅配便以外の手段（直接のご来社、電子メール、FAXなど）での開示等の請求等は受け付けておりません。
                </p>
              </li>
              <li className="disclosure_item">
                <h5 className="section_subtitle_lower">2. 本人確認書類</h5>
                <p className="text">
                  ご本人によるお申し込みの場合: 本人の公的証明書（写し）
                  <br />
                  代理人によるお申し込みの場合:
                  下記の書類のうち該当するもののすべて。
                </p>
                <ul className="disclosure_list-gapped">
                  <li className="disclosure_list_item">
                    代理権確認書類
                    <dl className="disclosure_dl">
                      <dt>法定代理人:</dt>
                      <dd>戸籍謄本、戸籍抄本、家庭裁判所の証明書等</dd>
                    </dl>
                    <dl className="disclosure_dl">
                      <dt>任意代理人(以下のすべて):</dt>
                      <dd>
                        <ul className="disclosure_dl_list">
                          <li className="disclosure_dl_list_item">
                            当社指定の委任状（当社指定の委任状がお手元にない場合は、ご連絡ください。早急にご郵送します。）※印鑑登録された本人の印鑑の押印がされたもの。
                          </li>
                          <li className="disclosure_dl_list_item">
                            本人の印鑑登録証証明書
                          </li>
                        </ul>
                      </dd>
                    </dl>
                  </li>
                  <li className="disclosure_list_item">
                    代理人の身元確認書類
                    <p className="text">代理人の公的証明書（写し）</p>
                  </li>
                  <li className="disclosure_list_item">
                    本人の身元確認書類
                    <p className="text">本人の公的証明書（写し）</p>
                  </li>
                </ul>
                <div className="annotation">
                  <p className="text">
                    ※ご提示いただいた本人確認書類は、以下の通り利用いたします。ご同意いただける方のみ、開示等の請求等をお願いいたします。
                  </p>
                </div>
                <ul className="disclosure_list-no-gap">
                  <li className="disclosure_list_item">
                    当個人情報は、本人からの開示等の請求等に応じるために利用いたします。
                  </li>
                  <li className="disclosure_list_item">
                    本人確認に必要のない要配慮個人情報については墨塗りするなどして判読できないようにしてください。
                  </li>
                  <li className="disclosure_list_item">
                    法令に基づく場合を除いて、当個人情報を本人の同意なく第三者に提供することはありません。また、当個人情報の取扱いを委託する予定はありません。
                  </li>
                  <li className="disclosure_list_item">
                    本人確認書類等により本人確認が出来ない場合、開示等の請求等に応じられない場合がございます。
                  </li>
                  <li className="disclosure_list_item">
                    その他、当社の個人情報の取扱いについては当社のホームページをご覧下さい。
                  </li>
                </ul>
              </li>
              <li className="disclosure_item">
                <h5 className="section_subtitle_lower">3. 手数料</h5>
                <p className="text">
                  「利用目的の通知」あるいは「開示」につきましては、1件のお申込みにつき手数料として1,000円いただきます。1,000円分の郵便小為替を上記書類にあわせてご同封ください。
                  <br />
                  上記の通り手数料が同封されていなかった場合は、その旨ご連絡申し上げますが、所定の期間内にお支払いいただけない場合は開示等の請求等がなかったものといたします。なお、送付頂いた書類は原則としてご返却いたしません。
                </p>
              </li>
            </ol>

            <section className="disclosure_contact">
              <h4 className="section_subtitle">
                個人情報保護方針、個人情報苦情及び相談窓口
              </h4>
              <address className="address">
                〒100-6390　東京都千代田区丸の内2-4-1丸の内ビルディング18階
                コタエルHR株式会社
                <br />
                窓口: 相談窓口担当
                <br />
                E-mail：contact@kotaeru-hr.co.jp
                <br />
                (受付時間 月曜日～金曜日 祝祭日を除く 10時～16時)
              </address>
            </section>
          </div>
          <h3 className="section_subtitle">
            2-7. 保有個人データの安全管理のために講じた措置
          </h3>
          <ul className="measure_list">
            <li className="measure_list_item">
              <h4 className="section_subtitle_lower">基本方針の策定</h4>
              <p className="text">
                個人データの適正な取扱いの確保のため、「関係法令・ガイドライン等の遵守」、「質問及び苦情処理の窓口」等についての基本方針を策定しております。
              </p>
            </li>
            <li className="measure_list_item">
              <h4 className="section_subtitle_lower">
                個人データの取扱いに係る規律の整備
              </h4>
              <p className="text">
                取得、利用、保存、提供、削除・廃棄等の段階ごとに、取扱方法、責任者・担当者及びその任務等について個人データの取扱規程を策定しております。
              </p>
            </li>
            <li className="measure_list_item">
              <h4 className="section_subtitle_lower">組織的安全管理措置</h4>
              <p className="text">
                個人データの取扱いに関する責任者を設置するとともに、個人データを取り扱う従業者及び当該従業者が取り扱う個人データの範囲を明確化し、法や取扱規程に違反している事実又は兆候を把握した場合の責任者への報告連絡体制を整備しております。
                <br />
                個人データの取扱状況について、定期的に自己点検を実施するとともに、他部署や外部の者による監査を実施しております。
              </p>
            </li>
            <li className="measure_list_item">
              <h4 className="section_subtitle_lower">人的安全管理措置</h4>
              <p className="text">
                個人データの取扱いに関する留意事項について、従業者に定期的な研修を実施しております。
                <br />
                個人データについての秘密保持に関して従業者と契約を締結しております。
              </p>
            </li>
            <li className="measure_list_item">
              <h4 className="section_subtitle_lower">物理的安全管理措置</h4>
              <p className="text">
                個人データを取り扱う区域において、従業者の入退室管理及び持ち込む機器等の管理を行うとともに、権限を有しない者による個人データの閲覧を防止する措置を実施しております。
                <br />
                個人データを取り扱う機器、電子媒体及び書類等の盗難又は紛失等を防止するための措置を講じるとともに、事業所内の移動を含め、当該機器、電子媒体等を持ち運ぶ場合、容易に個人データが判明しないよう措置を実施しております。
              </p>
            </li>
            <li className="measure_list_item">
              <h4 className="section_subtitle_lower">技術的安全管理措置</h4>
              <p className="text">
                アクセス制御を実施して、担当者及び取り扱う個人情報データベース等の範囲を限定しております。
                <br />
                個人データを取り扱う情報システムを外部からの不正アクセス又は不正ソフトウェアから保護する仕組みを導入しております。
              </p>
            </li>
            <li className="measure_list_item">
              <h4 className="section_subtitle_lower">外的環境の把握</h4>
              <p className="text">
                当社は外国にサーバーがあるクラウドサービスを利用しており、保有個人データの安全管理のために、サーバーの所在地が我が国と同等の水準にあると認められる個人情報保護制度を有している外国として個人情報保護委員会規則で認められたEU圏内もしくは英国であること、若しくはCBRP認証を取得していることを確認し、いずれにも当てはまらない場合は、当該外国の制度等を把握した上で当該クラウドサービスの情報セキュリティ確保の確認など適切な安全管理措置を実施しております。
              </p>
              <div className="annotation">
                <p className="text">
                  なお、現在個人データの提供がある外国及びその国の制度等は、下記の通りです。
                </p>
              </div>
              <table className="table">
                <tbody>
                  <tr>
                    <td className="item">米国</td>
                    <td className="item_content">
                      FTC法第5条
                      <br />
                      <a
                        className="item_link md:hover-opaque"
                        href="https://www.ftc.gov/enforcement/statutes/federal-trade-commission-act"
                        target="_blank"
                        rel="noreferrer"
                      >
                        https://www.ftc.gov/enforcement/statutes/federal-trade-commission-act
                      </a>
                    </td>
                  </tr>

                  <tr>
                    <td className="item">シンガポール</td>
                    <td className="item_content">
                      Personal Data Protection Act
                      <br />
                      <a
                        className="item_link md:hover-opaque"
                        href="https://sso.agc.gov.sg/Act/PDPA2012"
                        target="_blank"
                        rel="noreferrer"
                      >
                        https://sso.agc.gov.sg/Act/PDPA2012
                      </a>
                    </td>
                  </tr>

                  <tr>
                    <td className="item">香港</td>
                    <td className="item_content">
                      Personal Data (Privacy) Ordinance
                      <br />
                      <a
                        className="item_link md:hover-opaque"
                        href="https://www.pcpd.org.hk/english/data_privacy_law/ordinance_at_a_Glance/ordinance.html"
                        target="_blank"
                        rel="noreferrer"
                      >
                        https://www.pcpd.org.hk/english/data_privacy_law/ordinance_at_a_Glance/ordinance.html
                      </a>
                    </td>
                  </tr>

                  <tr>
                    <td className="item">オーストラリア</td>
                    <td className="item_content">
                      連邦プライバシー法
                      <br />
                      <a
                        className="item_link md:hover-opaque"
                        href="https://www.legislation.gov.au/Details/C2014C00076"
                        target="blank"
                      >
                        https://www.legislation.gov.au/Details/C2014C00076
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </li>
          </ul>
          <ul className="note_list">
            <li className="note_item">
              ※注意事項
              <ul className="note_list_sub">
                <li className="note_list_sub_item">
                  郵送や配送途中の書類の紛失、事故による未着につきましては、当社では責任を負いかねます。
                </li>
                <li className="note_list_sub_item">
                  必要事項を全てご記入下さい。書類に不備がある場合は、返送させていただく場合がございます。
                </li>
                <li className="note_list_sub_item">
                  個人情報保護法の例外規定にあたる場合など、開示等の請求等にお答えできない場合がございます。
                </li>
                <li className="note_list_sub_item">
                  内容により、お時間をいただく場合がございます。
                </li>
                <li className="note_list_sub_item">
                  開示等の請求等にともない収集した個人情報は、開示等の請求等に必要な範囲のみで取扱うものとします。提出していただいた書面は当社で適切に廃棄いたします。
                </li>
                <li className="note_list_sub_item">
                  「訂正等」、「利用停止等」の結果、該当するサービスがご利用いただけなくなることがあります。あらかじめご了承下さい。
                </li>
              </ul>
            </li>
            <li className="note_item">
              ※「保有個人データ」とは、電子計算機を用いて検索することができるように体系的に構成した情報の集合物又は一定の規則に従って整理、分類し、目次、索引、符合などを付すことによって特定の個人情報を容易に検索できるように体系的に構成した情報の集合物を構成する個人情報であって、当社が、本人から求められる開示、内容の訂正、追加又は削除、利用の停止、消去及び第三者への提供の停止の求めのすべてに応じることができる権限を有するものをいいます。詳しくは、「個人情報苦情及びご相談窓口」までご連絡ください。
            </li>
          </ul>
        </section>
      </div>

      <CommonBreadCrumbs items={breadcrumbs} />
    </>
  )
}
